import React from "react";
import {
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  FormHelperText,
} from "@mui/material";
import { Field, useFormikContext } from "formik";
import { useDropdown } from "src/hooks/useDropdown.hook";

const CompanySelectionStep = () => {
  const { data: companies = [] } = useDropdown("company");
  const { setFieldValue, setFieldTouched } = useFormikContext();
  return (
    <Box>
      <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
        Select Company
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Field name="companyId">
            {({ field, meta }) => (
              <FormControl
                size="small"
                fullWidth
                error={meta.touched && Boolean(meta.error)}
              >
                <InputLabel id="company-select-label">Select a company</InputLabel>
                <Select
                  labelId="company-select-label"
                  id="company-select"
                  label="Select a company"
                  value={field.value || ""}
                  onBlur={field.onBlur}
                  onChange={(e) => {
                    setFieldValue("companyId", e.target.value);
                    setFieldTouched("companyId", true, false);
                  }}
                >
                  <MenuItem value="">
                    <em>Select a company</em>
                  </MenuItem>
                  {companies.map((c) => (
                    <MenuItem key={c.id} value={c.id}>
                      {c.value}
                    </MenuItem>
                  ))}
                </Select>
                {meta.touched && meta.error && (
                  <FormHelperText>{meta.error}</FormHelperText>
                )}
              </FormControl>
            )}
          </Field>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CompanySelectionStep;
